<div class="card bg-emphasis bg-opacity-25">

  <div class="card-header fw-bold small text-truncate text text-uppercase" *ngIf="widget.showTitle">
    <div class="d-flex">
      <span class="flex-grow-1 fw-bold small text">
          {{widget.name}}
      </span>                    
      <span>
        <a class="button" (click)="refresh()">
          <i class="fa fa-refresh"></i>
        </a>
      </span>
    </div>
  </div>  
  
  <div class="card-body p-2">

    <div class="video-container">
      <!-- Video Player -->
      <div class="video-player-container">
        <div class="video-player">
          <div class="video-player-inner">
            <video #videoSource [autoplay]="widget.autoPlayVideo" controls *ngIf="isLoaded && isVideos && selectedVideo && (selectedVideo.metaData['content-type'] == 'video/mp4' || selectedVideo.metaData['content-type'] == 'application/octet-stream')">
              <source [src]="selectedVideo.value">
            </video>
            <div class="demo-img-container">
              <div class="demo-img-wrapper" *ngIf="isLoaded && isVideos && selectedVideo && selectedVideo.metaData['content-type'] == 'image/jpeg'">
                <img #imgSource id="imgSource"  [attr.src]="selectedVideo?.value"/>
                <div *ngIf="widget.showImageMetaData">
                  <div *ngFor="let object of overlays" >
                    <div class="object-rectangle" style="left:{{object[0]}}%; top:{{object[1]}}%; width:{{object[2]}}%; height:{{object[3]}}%">
                      <table class="table-naked object-info">
                        <tbody>
                          <tr>
                            <td>{{object[4]}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <ng-container *ngIf="!isLoaded || !isVideos">
              <span *ngIf="isLoaded && !isVideos">No Videos</span>
              <span *ngIf="!isLoaded">Loading...</span>
            </ng-container>
          </div>
        </div>
        <p *ngIf="selectedVideo">{{ selectedVideo.timeStamp | date:'medium' }}</p>
      </div>
      <!-- Video Selection -->
      <div class="video-library" *ngIf="widget.carouselEnabled && isLoaded && isVideos">
        <button class="video-library-navigation btn btn-primary" (click)="decrementCarousel()"><i class="fa fa-chevron-left"></i></button>

        <div class="video-library-videos">
          <button class="video-select" *ngFor="let video of videos | slice:carouselPosition:carouselPosition+carouselCount" (click)="selectVideo(video)" [class.selected-video]="video.value === selectedVideo.value">
            <div class="video-select-thumbnail">
              <div *ngIf="video.metaData['content-type'] == 'video/mp4' || video.metaData['content-type'] == 'application/octet-stream'" class="video-icon"><i class="fa fa-play"></i></div>
              <div *ngIf="video.metaData['content-type'] == 'image/jpeg'" class="video-icon"><i class="fa fa-camera"></i></div>
              <div class="video-select-inner">
                <video [attr.src]="video.value" *ngIf="video.metaData['content-type'] == 'video/mp4' || video.metaData['content-type'] == 'application/octet-stream'"></video>
                <img [attr.src]="video.value" *ngIf="video.metaData['content-type'] == 'image/jpeg'"/>                
              </div>
            </div>
            <div class="video-select-meta">
              <p>{{ video.timeStamp | date:'medium' }}</p>
            </div>
          </button>
        </div>

        <button class="video-library-navigation btn btn-primary" (click)="incrementCarousel()"><i class="fa fa-chevron-right"></i></button>
      </div>
    </div>

  </div>
  <div class="card-arrow">
    <div class="card-arrow-top-left"></div>
    <div class="card-arrow-top-right"></div>
    <div class="card-arrow-bottom-left"></div>
    <div class="card-arrow-bottom-right"></div>
  </div>
</div>
